<template>
  <div>
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Viabilidade" />

      <Lynx-Button
        text="Adicionar Viabilidade"
        class="mb-4"
        icon="Plus"
        @click.native="openCreateModal"
        size="small"
        icon-size="3"
        v-if="$hasPermission('criar viabilidade')"
      />

      <Lynx-Button
        text="Gerar Relatório"
        class="mb-4"
        icon="Download"
        @click.native="gerarRelatorio"
        size="small"
        icon-size="3"
      />
      <Lynx-Button
        text="Atualizar"
        class="mb-4"
        icon="Reload"
        @click.native="fetchViabilidades"
        size="small"
        icon-size="3"
      />
    </div>

    <!-- <div class="w-full flex gap-1 justify-end mb-3">
      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="gerarTaxasAusentes()"
      >
        Gerar Taxas Ausentes
      </v-btn>

      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="atualizarTaxaViabilidades()"
      >
        Atualizar Viabilidades
      </v-btn>
    </div> -->

    <div class="flex gap-4">
      <label class="pb-4 w-1/4">
        <Lynx-Label label="Pesquise a Cidade" />

        <Lynx-Input v-model="filtros.cidade" placeholder="Digite a Cidade" />
      </label>

      <label class="pb-4 w-1/4">
        <Lynx-Label label="Pesquise o Estado" />

        <Lynx-Input v-model="filtros.estado" placeholder="Digite o Estado" />
      </label>

      <label class="pb-4 w-1/4">
        <b-field label="Última atualização">
          <b-select
            placeholder="Selecione um período"
            v-model="ultima_atualizacao_filter"
          >
            <option
              v-for="item in ultima_atualizacao_filter_options"
              :value="item.value"
              :key="item.id"
              v-text="item.label"
            />
          </b-select>
        </b-field>
      </label>
    </div>

    <b-table
      v-if="pagination"
      hoverables
      class="w-full pb-8"
      paginated
      :data="viabilidadesFiltered"
      :loading="loading"
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
    >
      <template slot-scope="props">
        <b-table-column label="Cidade" field="cidade">
          <span v-text="props.row.cidade" />
        </b-table-column>

        <b-table-column label="Estado" field="estado">
          <span v-text="props.row.estado" />
        </b-table-column>
        <b-table-column label="Ultima atualização">
          <span
            class="py-1 px-2 text-neutral-100 text-xs rounded"
            :class="
              getUpdatedAtTheme(getUpdatedAtDifference(props.row.updated_at))
            "
          >
            {{ getUpdatedAtDifference(props.row.updated_at) | mes }}
          </span>
        </b-table-column>
        <b-table-column label="Ações">
          <div class="flex text-sm items-center">
            <a
              href="#"
              class="mr-4 bg-primary-600 rounded-full p-2"
              @click.prevent="openViewModal(props.row.id)"
              v-if="$hasPermission('ver viabilidade')"
            >
              <Icon-Eye class="text-neutral-100" size="4" />
            </a>
            <a
              href="#"
              class="bg-error-base rounded-full p-2"
              @click.prevent="deleteViabilidade(props.row.id)"
              v-if="$hasPermission('excluir viabilidade')"
            >
              <Icon-Trash class="text-neutral-100" size="4" />
            </a>

            <Logs v-if="logs" :logs="props.row.activities" :loading="loading" />
          </div>
        </b-table-column>
      </template>
    </b-table>
    <Not-Found-Data
      v-else-if="!loading"
      text="Nenhuma viabilidade registrada"
    />
    <b-modal :active.sync="viewModal" v-if="viewModal" width="600px">
      <View-Viabilidade-Municipal
        :viabilidade-id="currentViabilidadeId"
        @edit-viabilidade="onEditViabilidade"
      />
    </b-modal>
    <b-modal :active.sync="createModal" v-if="createModal" width="600px">
      <Create-Viabilidade-Municipal @create-viabilidade="onCreateViabilidade" />
    </b-modal>
  </div>
</template>

<script>
import {
  indexViabilidadeMunicipalRequest,
  destroyViabilidadeMunicipalRequest,
} from "@/services/requests/viabilidadeMunicipal";
import ViewViabilidadeMunicipal from "@/views/viabilidade/municipal/View";
import CreateViabilidadeMunicipal from "@/views/viabilidade/municipal/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import Logs from "@/views/logs/Logs";

import moment from "moment";

export default {
  name: "ViabilidadeMunicipalIndex",
  components: {
    ViewViabilidadeMunicipal,
    CreateViabilidadeMunicipal,
    NotFoundData,
    Logs,
  },
  data() {
    return {
      loading: false,
      createModal: false,
      viewModal: false,
      viabilidades: {
        data: [],
        pagination: {
          total: 0,
          per_page: 0,
          current_page: 0,
        },
      },
      logs: [],
      currentViabilidadeId: null,
      ultima_atualizacao_filter: "todas",
      ultima_atualizacao_filter_options: [
        {
          value: "todas",
          label: "Todas",
        },
        {
          value: 6,
          label: "6 meses atrás",
        },
        {
          value: 12,
          label: "12 meses atrás",
        },
      ],
      filtros: {
        cidade: null,
        estado: null,
        perPage: 10,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  filters: {
    mes(val) {
      return val === 1 ? `${val} mês atras` : `${val} meses atras`;
    },
  },
  computed: {
    viabilidadesFiltered() {
      return this.viabilidades.data.filter((curr) => {
        if (this.ultima_atualizacao_filter === "todas") return true;
        if (this.ultima_atualizacao_filter === 6)
          return this.getUpdatedAtDifference(curr.updated_at) >= 6;
        if (this.ultima_atualizacao_filter === 12)
          return this.getUpdatedAtDifference(curr.updated_at) >= 12;
      });
    },
    pagination() {
      return this.viabilidades.pagination;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.fetchViabilidades();
    },
    current_page(paginaAtual) {
      this.filtros.page = paginaAtual;
      this.fetchViabilidades();
    },
  },
  methods: {
    fetchViabilidades() {
      this.loading = true;
      if (this.filtros.cidade === "") this.filtros.cidade = null;
      if (this.filtros.estado === "") this.filtros.estado = null;
      const { filtros } = this;
      indexViabilidadeMunicipalRequest(filtros)
        .then((res) => (this.viabilidades = res.data))
        .finally(() => (this.loading = false));
    },
    getUpdatedAtDifference(val) {
      const updatedAtMonth = moment(val);
      const now = moment();
      return now.diff(updatedAtMonth, "month");
    },
    getUpdatedAtTheme(val) {
      if (val < 6) return "bg-info-base";
      if (val < 12) return "bg-warning-base";
      return "bg-error-base";
    },
    openCreateModal() {
      this.createModal = true;
    },
    openViewModal(currentViabilidadeId) {
      this.currentViabilidadeId = currentViabilidadeId;
      this.viewModal = true;
    },
    onEditViabilidade() {
      this.fetchViabilidades();
      this.viewModal = false;
    },
    onCreateViabilidade() {
      this.fetchViabilidades();
      this.createModal = false;
    },
    deleteViabilidade(id) {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente excluir esta viabilidade?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: () => this.onDeleteViabilidade(id),
      });
    },
    onDeleteViabilidade(id) {
      destroyViabilidadeMunicipalRequest(id)
        .then(() => {
          this.$snack.success("Viabilidade excluida com sucesso");
          this.fetchViabilidades();
        })
        .catch(() =>
          this.$snack.error("Não foi possivel excluir a viabilidade")
        );
    },
    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_API_URL}/viabilidade/relatorio/?token=${this.$store.getters.getToken}`,
        "_blank"
      );
    },
    onPageChange(page) {
      this.current_page = page;
    },
    gerarTaxasAusentes() {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente gerar as taxas ausentes?",
        confirmText: "Gerar",
        cancelText: "Cancelar",
        type: "is-success",
        onConfirm: () => this.$store.dispatch("fila/gerarTaxasAusentes"),
      });
    },

    atualizarTaxaViabilidades() {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente atualizar as viabilidades?",
        confirmText: "Atualizar",
        cancelText: "Cancelar",
        type: "is-success",
        onConfirm: () => this.$store.dispatch("fila/atualizarVencimentosTaxasViabilidade"),
      });
    },

   
  },
  beforeMount() {
    this.fetchViabilidades();
  },
};
</script>